"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DSTT007_List = void 0;
const react_1 = __importDefault(require("react"));
const component_1 = require("./component");
const RegistButton_1 = require("../RegistButton");
exports.DSTT007_List = react_1.default.memo(({ isTeacher = false }) => {
    const handlerButtonClick = () => {
        APP.eventManager.publish('UPDATE_DETAIL_MENU', {
            menuDetail: 'regist',
            id: undefined,
        });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(component_1.ReplayRoomTable, { isHome: false }),
        isTeacher && react_1.default.createElement(RegistButton_1.RegistButton, { handlerButtonClick: handlerButtonClick })));
});
